import {Pipe, PipeTransform} from '@angular/core';

import {FormuleProductEnum} from "@shared/constants/formule-product.enum";
import { includes }         from '@shared/helper/LDHelper';


const LIBS = {
    '1':  () => {
        return '<sup>(1)</sup>Ce bilan a été établi à titre indicatif, sur la base des éléments que vous avez déclarés. Cette étude ' +
               'ainsi que les pré-estimations tarifaires annoncées ne constituent en aucun cas un engagement contractuel de ' +
               'Groupama.'
    },
    '2': () => {
        return '<br><br><sup>(2)</sup>Exemple pour un prêt de 180 000 € sur 20 ans pour un couple de cadres de 37 ans, non-fumeurs, avec un taux ' +
               'annuel effectif d\'assurance initial de 0,66 % ramené à 0,24 % par emprunteur assuré à 100 % chacun en Décès, Perte totale ' +
               'et irréversible d’autonomie, Incapacité temporaire totale, Invalidité permanente totale et Option Sécurité ' +
               '(soit une économie exacte de 14 810 €). Sous réserve de décision médicale de l’assureur et conditions contractuelles.';
    },
    '3': () => {
        return '<br><br><sup>(3)</sup>Calcul du tarif hors professions et/ou sports à risques et hors avantages commerciaux éventuels.';
    },
    '4': () => {
        return '<br><br><sup>(4)</sup>Ce tarif n’inclut pas les 15€ de frais d’adhésion dû au moment de la première souscription.';
    }
}

const INFOS_4 = [FormuleProductEnum.FORMULE_GROUPAMA_SERENITE_OBSEQUES, FormuleProductEnum.FORMULE_GROUPAMA_SECURITE, FormuleProductEnum.FORMULE_GROUPAMA_SECURITE_RENTE_EDUCATION];
const INFOS_3 = [FormuleProductEnum.FORMULE_GROUPAMA_SECURITE];

@Pipe({standalone:true,name: 'FooterLibelleSelfcarePipe'})
export class FooterLibelleSelfcarePipe implements PipeTransform {
    transform(datas: any, eligibitesEmprunt: boolean): string {
        const libs = new Array<string>();
        libs.push(LIBS['1']());
        libs.push(LIBS['2']());

        let infos3 = datas.eligibites.filter(e => includes(INFOS_3, e.key));
        if(infos3.length > 0) {
            libs.push(LIBS['3']());
        }

        let infos4 = datas.eligibites.filter(e => includes(INFOS_4, e.key));
        if(infos4.length > 0) {
            libs.push(LIBS['4']());
        }
        return libs.join('');
    }
}
